import React from 'react';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Spinner,
  Stack,
} from '@chakra-ui/react';
import { Button } from '~/components/Button';
import { ColorfulBar } from '~/components/Header/ColorfulBar';

interface ConfirmationDialogProps {
  titulo: string;
  onClose: () => void;
  confirmar: () => void;
  isOpen: boolean;
  isDisabled?: boolean;
  hasCloseButton?: boolean;
  btnConfirmText?: string;
  btnCancelText?: string;
  colorfulBar?: boolean;
  size?: string;
  loading?: boolean;
  closeOnOverlayClick?: boolean;
  closeOnEsc?: boolean;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  children,
  titulo,
  onClose,
  confirmar,
  isOpen,
  isDisabled = false,
  hasCloseButton = true,
  btnConfirmText = 'Confirmar',
  btnCancelText = 'Cancelar',
  colorfulBar = true,
  size = 'xl',
  loading = false,
  closeOnOverlayClick = true,
  closeOnEsc = true,
}) => {
  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={undefined}
      onClose={onClose}
      isOpen={isOpen}
      isCentered
      size={size}
      closeOnOverlayClick={closeOnOverlayClick}
      closeOnEsc={closeOnEsc}
    >
      <AlertDialogOverlay />
      <AlertDialogContent>
        {colorfulBar && <ColorfulBar />}
        <AlertDialogHeader fontSize="lg">{titulo}</AlertDialogHeader>
        <AlertDialogCloseButton isDisabled={loading} />
        <AlertDialogBody>
          <Stack gridGap={2}>{children}</Stack>
        </AlertDialogBody>
        <AlertDialogFooter>
          {hasCloseButton && (
            <Button onClick={onClose} variant="secondary" isDisabled={loading}>
              {btnCancelText}
            </Button>
          )}
          <Button ml={3} onClick={confirmar} isDisabled={isDisabled}>
            {btnConfirmText}
            {loading && <Spinner style={{ marginLeft: '10px' }} />}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
